/* eslint-disable import/prefer-default-export */
export const GET_WALL_CHART = 'GET_WALL_CHART'
